// FormStepper.jsx (atualizado — inclua/cole no lugar do seu arquivo atual)
import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../infra/apiConfig';
import { useForm } from 'react-hook-form';
import { Stepper, Step, StepLabel, Button, Box } from '@mui/material';

import Step1_InfoEquipe from './Step1_InfoEquipe';
import Step2_DetalhesProjeto from './Step2_DetalhesProjeto';

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import logoAcs from '../img/logoAcs2.png';

const steps = ['Informações da Equipe', 'Detalhes do Projeto'];

// Lista de campos a serem validados em cada passo
const stepFields = [
  ['nomeEquipe', 'novosMembros'],
  [
    'nomeIniciativa', 'areaTematica', 'problemaObjetivo', 'publicoBeneficiario',
    'caraterInovacao', 'impactosPrevistos', 'potencialExecucao', 'contribuicaoParceria',
    'etapas'
  ]
];

// ------------------------
// Helpers de formatação
// ------------------------
const formatCPF = (value) => {
  if (!value) return "";
  const v = value.replace(/\D/g, '');
  return v.replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .substring(0, 14);
};

const formatTelefone = (value) => {
  if (!value) return "";
  const v = value.replace(/\D/g, '');
  if (v.length <= 2) return v;
  if (v.length <= 6) return `(${v.slice(0, 2)}) ${v.slice(2)}`;
  if (v.length <= 10) return `(${v.slice(0, 2)}) ${v.slice(2, 6)}-${v.slice(6)}`;
  return `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7)}`;
};

const mapAreaTematica = (val) => {
  switch (val) {
    case 'devWeb': return 'Programação e Desenvolvimento Web';
    case 'redesTI': return 'Redes e Tecnologia da Informação';
    case 'comunicacaoMidia': return 'Comunicação e Mídias Digitais';
    case 'externosCategoria': return 'Categoria para Grupos Externos';
    default: return val || '';
  }
};

const mapSerie = (val) => {
  if (!val) return '';
  if (val === '9_fundamental') return '9º Ano - Ensino Fundamental';
  if (val === '8_fundamental') return '8º Ano - Ensino Fundamental';
  if (val === '1_medio') return '1º Ano - Ensino Médio';
  if (val === '2_medio') return '2º Ano - Ensino Médio';
  if (val === '3_medio') return '3º Ano - Ensino Médio';
  return val;
};

const mapMes = (val) => {
  const meses = {
    1: 'Janeiro', 2: 'Fevereiro', 3: 'Março', 4: 'Abril', 5: 'Maio', 6: 'Junho',
    7: 'Julho', 8: 'Agosto', 9: 'Setembro', 10: 'Outubro', 11: 'Novembro', 12: 'Dezembro'
  };
  return meses[Number(val)] || '';
};

// ------------------------
// Componente principal
// ------------------------
const FormStepper = () => {
  const [activeStep, setActiveStep] = useState(0);

  const { control, register, handleSubmit, trigger, watch, getValues, reset, formState: { errors } } = useForm({
    defaultValues: {
      novosMembros: [],
      etapas: []
    },
    mode: 'onChange'
  });

  const handleNext = async () => {
    const fieldsToValidate = stepFields[activeStep];
    const isValid = await trigger(fieldsToValidate);

    if (isValid) {
      setActiveStep((prev) => prev + 1);
    } else {
      console.log("Validação falhou. Erros:", errors);
      alert("Por favor, verifique os campos obrigatórios antes de avançar.");
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const onSubmit = async (data) => {
    console.log("Dados completos do formulário:", data);

    const token = localStorage.getItem('token');

    if (!token) {
      alert("Você precisa estar logado para enviar a inscrição.");
      return;
    }

    try {
      const equipeResponse = await axios.post(
        `${API_BASE_URL}/equipe`,
        {
          nomeEquipe: data.nomeEquipe,
          novosMembros: data.novosMembros,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Equipe salva com sucesso:", equipeResponse.data);

      const projetoResponse = await axios.post(
        `${API_BASE_URL}/projeto`,
        {
          nomeIniciativa: data.nomeIniciativa,
          areaTematica: data.areaTematica,
          problemaObjetivo: data.problemaObjetivo,
          publicoBeneficiario: data.publicoBeneficiario,
          caraterInovacao: data.caraterInovacao,
          impactosPrevistos: data.impactosPrevistos,
          potencialExecucao: data.potencialExecucao,
          contribuicaoParceria: data.contribuicaoParceria,
          etapas: data.etapas,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Projeto salvo com sucesso:", projetoResponse.data);

      alert('✅ Inscrição enviada com sucesso! Os dados foram salvos no sistema.');
    } catch (error) {
      console.error("Erro ao enviar inscrição:", error);

      const status = error.response?.status;
      const data = error.response?.data;

      if (status === 409) {
        const cpf = data?.cpf;
        const mensagem = cpf
          ? `⚠️ O CPF ${cpf} já está cadastrado no sistema. Verifique e tente novamente.`
          : "⚠️ Um dos CPFs informados já está cadastrado no sistema. Verifique e tente novamente.";
        alert(mensagem);
        return;
      }

      console.log("Detalhe da resposta do backend:", error.response?.data, error.response?.status);

      alert("❌ Ocorreu um erro ao salvar os dados. Verifique o console para mais detalhes.");
    }
  };

  // =============================================
  // Função para gerar PDF organizado (dados + líder)
  // =============================================
  // =============================================
  // Função para gerar PDF organizado (dados + líder)
  // =============================================
const gerarPDF = async () => {
  try {
    const token = localStorage.getItem('token');

    let liderData = null;
    if (token) {
      try {
        const res = await axios.get(`${API_BASE_URL}/perfil`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        liderData = res.data;
      } catch (err) {
        console.warn("Não foi possível buscar dados do líder para o PDF:", err);
      }
    }

    const data = getValues();
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 15;
    let cursorY = 18;

    // ===============================
    // LOGO CENTRALIZADA
    // ===============================
    const img = new Image();
    img.src = logoAcs;
    const imgWidth = 20;
    const aspectRatio = img.height / img.width || 1;
    const imgHeight = imgWidth * aspectRatio;
    const imgX = (pageWidth - imgWidth) / 2;
    doc.addImage(img, 'PNG', imgX, cursorY, imgWidth, imgHeight);
    cursorY += imgHeight + 6;

    // Cabeçalho
    doc.setFontSize(16);
    doc.text("Inscrição - Protótipo de Projeto", pageWidth / 2, cursorY, { align: 'center' });
    cursorY += 6;
    doc.setFontSize(9);
    doc.text(`Gerado em: ${new Date().toLocaleString()}`, margin, cursorY);
    cursorY += 10;

    // ==============================
    // 1. INFORMAÇÕES DA EQUIPE
    // ==============================
    doc.setFontSize(12);
    doc.text("1. Informações da Equipe", margin, cursorY);
    cursorY += 6;
    doc.setFontSize(10);
    doc.text(`Nome da equipe: ${data.nomeEquipe || ''}`, margin, cursorY);
    cursorY += 8;

    const membros = [];

    if (liderData) {
      membros.push({
        tipo: 'lider',
        dados: [
          liderData.nome_completo || '',
          liderData.cpf ? formatCPF(liderData.cpf) : '',
          liderData.data_nascimento ? new Date(liderData.data_nascimento).toLocaleDateString('pt-BR') : '',
          liderData.telefone ? formatTelefone(liderData.telefone) : '',
          liderData.escola || '',
          mapSerie(liderData.serie) || 'Líder'
        ]
      });
    }

    (data.novosMembros || []).forEach(m => {
      membros.push({
        tipo: 'membro',
        dados: [
          m.nome_completo || '',
          m.cpf || '',
          m.data_nascimento ? new Date(m.data_nascimento).toLocaleDateString('pt-BR') : '',
          m.telefone || '',
          m.escola || '',
          mapSerie(m.serie)
        ]
      });
    });

    if (membros.length > 0) {
      autoTable(doc, {
        startY: cursorY,
        head: [['Nome', 'CPF', 'Data Nasc.', 'Telefone', 'Escola', 'Série']],
        body: membros.map(m => m.dados),
        styles: { fontSize: 9, valign: 'middle' },
        headStyles: { fillColor: [37, 99, 235], textColor: 255 },
        bodyStyles: { textColor: [0, 0, 0] },
        didParseCell: function (data) {
          if (data.section === 'body' && membros[data.row.index]?.tipo === 'lider') {
            data.cell.styles.fillColor = [220, 230, 255];
            data.cell.styles.fontStyle = 'normal';
          }
        },
      });
      cursorY = doc.lastAutoTable.finalY + 8;
    }

    // ==============================
    // 2. DETALHES DO PROJETO
    // ==============================
    if (cursorY > 260) { doc.addPage(); cursorY = 18; }
    doc.setFontSize(12);
    doc.text("2. Detalhes do Projeto", margin, cursorY);
    cursorY += 8;
    doc.setFontSize(10);
    doc.text(`Nome da iniciativa: ${data.nomeIniciativa || ''}`, margin, cursorY);
    cursorY += 6;
    doc.text(`Área temática: ${mapAreaTematica(data.areaTematica)}`, margin, cursorY);
    cursorY += 8;

    const sections = [
      { title: 'Apresente o objetivo central do protótipo de projeto', key: 'problemaObjetivo' },
      { title: 'Apresentar o público que será beneficiado com o protótipo de projeto', key: 'publicoBeneficiario' },
      { title: 'Apresente o caráter inovador do protótipo de projeto para o território de Lagoa de Itaenga', key: 'caraterInovacao' },
      { title: 'Apresente a relevância e impacto (Viabilidade) do projeto no desenvolvimento para o território de Lagoa de Itaenga', key: 'impactosPrevistos' },
      { title: 'Apresenta a proposição da solução para um problema concreto vivenciado por uma comunidade ou grupo social (ligadas a cultura, educação, saúde, agricultura, cidadania, esporte e lazer ou áreas afins), no território de Lagoa de Itaenga', key: 'potencialExecucao' },
      { title: 'Indique possível contribuição e parceria para o desenvolvimento econômico e social do projeto', key: 'contribuicaoParceria' },
    ];

    const letters = ['a', 'b', 'c', 'd', 'e', 'f'];

    sections.forEach((sec, idx) => {
      if (cursorY > 260) { doc.addPage(); cursorY = 18; }

      doc.setFontSize(11);
      doc.setFont(undefined, 'bold');
      const titulo = `${letters[idx]}) ${sec.title}:`;
      const tituloQuebrado = doc.splitTextToSize(titulo, pageWidth - margin * 2);
      doc.text(tituloQuebrado, margin, cursorY);
      cursorY += tituloQuebrado.length * 6 + 4;

      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      const text = data[sec.key] || '';
      const split = doc.splitTextToSize(text, pageWidth - margin * 2);
      doc.text(split, margin, cursorY);
      cursorY += split.length * 6 + 6;
    });

    // ==============================
    // 3. ETAPAS DO PROJETO
    // ==============================
    const etapas = (data.etapas || []).map(e => [mapMes(e.mes), e.acao || '']);
    if (etapas.length > 0) {
      if (cursorY > 240) { doc.addPage(); cursorY = 18; }
      doc.setFontSize(11);
      doc.text('Etapas de Desenvolvimento e Implantação:', margin, cursorY);
      cursorY += 6;
      autoTable(doc, {
        startY: cursorY,
        head: [['Mês', 'Ação planejada']],
        body: etapas,
        styles: { fontSize: 10 },
        headStyles: { fillColor: [37, 99, 235], textColor: 255 },
        theme: 'grid',
      });
      cursorY = doc.lastAutoTable.finalY + 6;
    }

    // ==============================
    // 4. RODAPÉ - ASSINATURAS
    // ==============================
    if (cursorY > 230) { doc.addPage(); cursorY = 18; }
    doc.setFontSize(11);
    doc.text('Assinaturas dos Participantes:', margin, cursorY);
    cursorY += 10;

    const linha = '__________________________________________';
    doc.setFontSize(10);

    membros.forEach((membro) => {
      const nome = membro.dados[0];
      doc.text(linha, margin, cursorY);
      doc.text(nome, margin, cursorY + 5);
      cursorY += 20;
      if (cursorY > 260) {
        doc.addPage();
        cursorY = 20;
      }
    });

    // ==============================
    // SALVAR PDF
    // ==============================
    const safeName = (data.nomeEquipe || 'inscricao_projeto')
      .replace(/[\\/:"*?<>|]+/g, '')
      .replace(/\s+/g, '_');

    doc.save(`${safeName}.pdf`);

  } catch (err) {
    console.error("Erro ao gerar PDF:", err);
    alert("❌ Erro ao gerar PDF. Veja o console para detalhes.");
  }
};




  return (
    <div className="w-full max-w-4xl mx-auto p-8 bg-white rounded-lg shadow-lg">
      <Stepper activeStep={activeStep} alternativeLabel sx={{
        '& .MuiStepLabel-label.Mui-active': { color: '#1d4ed8' },
        '& .MuiStepLabel-label.Mui-completed': { color: '#1d4ed8' },
        '& .MuiStepLabel-label': { color: '#6b7280' },
        '& .MuiSvgIcon-root': { color: '#9ca3af' },
        '& .MuiSvgIcon-root.Mui-active': { color: '#2563eb' },
        '& .MuiSvgIcon-root.Mui-completed': { color: '#2563eb' },
      }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <form onSubmit={handleSubmit(onSubmit)} className="mt-8">
        <div className="min-h-[400px]">
          {activeStep === 0 && <Step1_InfoEquipe control={control} register={register} errors={errors} reset={reset} />}
          {activeStep === 1 && <Step2_DetalhesProjeto register={register} errors={errors} control={control} watch={watch} getValues={getValues} reset={reset} />}
        </div>

        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, mt: 4, borderTop: '1px solid #e5e7eb' }}>
          <Button
            color="inherit"
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{ mr: 1, color: '#4b5563' }}
          >
            Voltar
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />

          {activeStep === steps.length - 1 ? (
            <>
              <Button
                type="button"
                onClick={gerarPDF}
                variant="outlined"
                sx={{ mr: 2, color: '#2563eb', borderColor: '#2563eb', '&:hover': { borderColor: '#1d4ed8', backgroundColor: '#eff6ff' } }}
              >
                Salvar em PDF
              </Button>

              <Button type="submit" variant="contained" sx={{ bgcolor: '#2563eb', '&:hover': { bgcolor: '#1d4ed8' } }}>
                Salvar
              </Button>
            </>
          ) : (
            <Button onClick={handleNext} variant="contained" sx={{ bgcolor: '#2563eb', '&:hover': { bgcolor: '#1d4ed8' } }}>
              Próximo
            </Button>
          )}
        </Box>
      </form>
    </div>
  );
};

export default FormStepper;
